import { createContext, useContext, useState, useCallback } from 'react'
import './ConfirmModal.css'

const ConfirmContext = createContext(null)

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    title: 'Confirm',
    message: '',
    resolve: null
  })

  const confirm = useCallback((message, title = 'Confirm') => {
    return new Promise(resolve => {
      setState({ open: true, title, message, resolve })
    })
  }, [])

  const handleConfirm = () => {
    state.resolve(true)
    setState({ open: false, title: '', message: '', resolve: null })
  }

  const handleCancel = () => {
    state.resolve(false)
    setState({ open: false, title: '', message: '', resolve: null })
  }

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {state.open && (
        <div className="confirm-overlay" onClick={handleCancel}>
          <div className="confirm-modal" onClick={e => e.stopPropagation()}>
            <h4 className="confirm-title">{state.title}</h4>
            <p className="confirm-message">{state.message}</p>
            <div className="confirm-actions">
              <button className="confirm-btn confirm-btn--cancel" onClick={handleCancel}>
                Cancel
              </button>
              <button className="confirm-btn confirm-btn--confirm" onClick={handleConfirm}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  )
}

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext)
  if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider')
  return ctx.confirm
}
